import React, { useState } from "react";
import ReactDropdown from "react-dropdown";
import { NhanVayCombo } from "constants/nhanVayConst";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../actions/NhanVay/";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const SearchBarMobile = ({ onShow, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  return (
    <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
      <div data-repeater-list="car">
        <div
          data-repeater-item
          className="form row bg-search-form form-mobile-search"
        >
          <div className="text-right  search-p mb-1 " style={{ width: "100%" }}>
            <div className="form-search-mobile-new row">
              <div className="left-search-mobile-new" style={{ width: "85%" }}>
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataSearch.customerName}
                      onChange={updateTextValue("customerName")}
                      placeholder="Tên, sđt chủ nợ ..."
                    />
                    <div className="form-control-position" onClick={onSearch}>
                      <i className="mdi mdi-magnify"></i>
                    </div>
                  </fieldset>
                </div>{" "}
              </div>
              <div className="right-search-mobile-new">
                <div class="icon-search-mobile">
                  <a
                    href="#"
                    className="card-link blue darken-2"
                    onClick={onShow}
                  >
                    <i>
                      <PopoversBootrap
                        contentText="Tìm kiếm nâng cao"
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/icon-fitter-v2.png"
                          alt=""
                          style={{
                            scale: "0.9",
                            verticalAlign: "sub",
                            marginTop: "-2px",
                          }}
                        />
                      </PopoversBootrap>
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};
